let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a4H5g")).then(() => parcelRequire('53MDj'));